/** Shared API base URLs for domain services */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
export const BASE_URL = import.meta.env.VITE_BASE_URL
